export default function ConnectSection() {
  return (
    <section className="sec g conn" style={{ paddingBottom: "100px", backgroundColor: "#FFFFFF" }}>
      <div className="wrap">
        <div className="hd2 rv">
          <div>
            <small>익숙한 업무 도구를 AI Agent와 함께</small>
            <h2>
              다양한 업무 도구를
              {' '}
              <em>하나로 연결</em>
            </h2>
          </div>
        </div>
      </div>
      <div className="mq">
        <div className="tr">
          <div className="app core">
            <img src="/site/logos/acxion-on-admin.svg" alt="AcXion-On" />
            <small>관리자</small>
          </div>
          <div className="app">
            <span className="ic w">
              <img src="/site/logos/google-drive.svg" alt="" />
            </span>
            Google Drive
          </div>
          <div className="app">
            <span className="ic w">
              <img src="/site/logos/slack.svg" alt="" />
            </span>
            Slack
          </div>
          <div className="app">
            <span className="ic w">
              <img src="/site/logos/notion.svg" alt="" />
            </span>
            Notion
          </div>
          <div className="app">
            <span className="ic w">
              <img src="/site/logos/gmail.svg" alt="" />
            </span>
            메일
          </div>
          <div className="app">
            <span className="ic" style={{ background: "#2563EB14", color: "#2563EB" }}>
              <svg className="i">
                <use href="#globe" />
              </svg>
            </span>
            웹 검색
          </div>
          <div className="app core">
            <img src="/site/logos/acxion-on-admin.svg" alt="AcXion-On" />
            <small>관리자</small>
          </div>
          <div className="app">
            <span className="ic w">
              <img src="/site/logos/google-drive.svg" alt="" />
            </span>
            Google Drive
          </div>
          <div className="app">
            <span className="ic w">
              <img src="/site/logos/slack.svg" alt="" />
            </span>
            Slack
          </div>
          <div className="app">
            <span className="ic w">
              <img src="/site/logos/notion.svg" alt="" />
            </span>
            Notion
          </div>
          <div className="app">
            <span className="ic w">
              <img src="/site/logos/gmail.svg" alt="" />
            </span>
            메일
          </div>
          <div className="app">
            <span className="ic" style={{ background: "#2563EB14", color: "#2563EB" }}>
              <svg className="i">
                <use href="#globe" />
              </svg>
            </span>
            웹 검색
          </div>
        </div>
      </div>
      <div className="mq rev">
        <div className="tr">
          <div className="app core u">
            <img src="/site/logos/acxion-on-user.svg" alt="AcXion-On" />
            <small>사용자</small>
          </div>
          <div className="app">
            <span className="ic" style={{ background: "#0F172A14", color: "#0F172A" }}>
              <svg className="i">
                <use href="#server" />
              </svg>
            </span>
            MCP
          </div>
          <div className="app">
            <span className="ic" style={{ background: "#EA8A0C14", color: "#EA8A0C" }}>
              <svg className="i">
                <use href="#db" />
              </svg>
            </span>
            사내 ERP
          </div>
          <div className="app">
            <span className="ic" style={{ background: "#736CE314", color: "#736CE3" }}>
              <svg className="i">
                <use href="#book" />
              </svg>
            </span>
            사내 위키
          </div>
          <div className="app">
            <span className="ic w">
              <img src="/site/logos/aws.svg" alt="" />
            </span>
            Amazon Bedrock
          </div>
          <div className="app">
            <span className="ic w">
              <img src="/site/logos/openai.svg" alt="" />
            </span>
            OpenAI
          </div>
          <div className="app">
            <span className="ic w">
              <img src="/site/logos/anthropic.svg" alt="" />
            </span>
            Claude
          </div>
          <div className="app">
            <span className="ic w">
              <img src="/site/logos/gemini.svg" alt="" />
            </span>
            Gemini
          </div>
          <div className="app">
            <span className="ic" style={{ background: "#5B53D614", color: "#5B53D6" }}>
              <svg className="i">
                <use href="#mail" />
              </svg>
            </span>
            이메일 커넥터
          </div>
          <div className="app core u">
            <img src="/site/logos/acxion-on-user.svg" alt="AcXion-On" />
            <small>사용자</small>
          </div>
          <div className="app">
            <span className="ic" style={{ background: "#0F172A14", color: "#0F172A" }}>
              <svg className="i">
                <use href="#server" />
              </svg>
            </span>
            MCP
          </div>
          <div className="app">
            <span className="ic" style={{ background: "#EA8A0C14", color: "#EA8A0C" }}>
              <svg className="i">
                <use href="#db" />
              </svg>
            </span>
            사내 ERP
          </div>
          <div className="app">
            <span className="ic" style={{ background: "#736CE314", color: "#736CE3" }}>
              <svg className="i">
                <use href="#book" />
              </svg>
            </span>
            사내 위키
          </div>
          <div className="app">
            <span className="ic w">
              <img src="/site/logos/aws.svg" alt="" />
            </span>
            Amazon Bedrock
          </div>
          <div className="app">
            <span className="ic w">
              <img src="/site/logos/openai.svg" alt="" />
            </span>
            OpenAI
          </div>
          <div className="app">
            <span className="ic w">
              <img src="/site/logos/anthropic.svg" alt="" />
            </span>
            Claude
          </div>
          <div className="app">
            <span className="ic w">
              <img src="/site/logos/gemini.svg" alt="" />
            </span>
            Gemini
          </div>
          <div className="app">
            <span className="ic" style={{ background: "#5B53D614", color: "#5B53D6" }}>
              <svg className="i">
                <use href="#mail" />
              </svg>
            </span>
            이메일 커넥터
          </div>
        </div>
      </div>
    </section>
  );
}
